let endpoints = {
    backendHost: process.env.REACT_APP_API_URL || 'https://assistarobase-api-stg.azurewebsites.net',
    environment: 'development',
    stripePublicKey: 'pk_test_51IJIZDCKG0sqpKaI60Hc3q7U5w5SXDgGETuT1Qr4YtQWTUhcSKtCJfhfPvOJR3dHg4s9ry8jWz8Dc4Okq2nozahU00AQWmn0MB'
};

const hostname = window && window.location && window.location.hostname;
if (hostname === 'agreeable-tree-0a8796f03.5.azurestaticapps.net') {
    endpoints.backendHost = 'https://assistarobase-api-dev.azurewebsites.net';
}
else if (hostname === 'assistarobase-stg.azurewebsites.net') {
    endpoints.backendHost = 'https://assistarobase-api-stg.azurewebsites.net';
    endpoints.environment = 'production';
}
else if (hostname === 'app-stg.assistarobase.fr') {
    endpoints.backendHost = 'https://api-stg.assistarobase.fr';
    endpoints.environment = 'production';
}
else if (hostname === 'assistarobase.azurewebsites.net') {
    endpoints.backendHost = 'https://assistarobase-api.azurewebsites.net';
    endpoints.environment = 'production';
    endpoints.stripePublicKey = 'pk_live_51IJIZDCKG0sqpKaItpya3Gz49x84dbicsoJwgyUauGKPgXrbwr524c7cbxgRKmiDRxhKVECLv1FKSKHIs8QMmYfG00VO0jtDuc';
}
else if (hostname === 'app.assistarobase.fr') {
    endpoints.backendHost = 'https://api.assistarobase.fr';
    endpoints.environment = 'production';
    endpoints.stripePublicKey = 'pk_live_51IJIZDCKG0sqpKaItpya3Gz49x84dbicsoJwgyUauGKPgXrbwr524c7cbxgRKmiDRxhKVECLv1FKSKHIs8QMmYfG00VO0jtDuc';
}
export const EndPoints = endpoints;
